var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"unauthorize"},[_c('a-result',{staticClass:"unauthorize__result",attrs:{"status":"403","title":"403","sub-title":_vm.message}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }